<template>
    <modal v-model="opened" :transition='0' :append-to-body="true" :backdrop="false">
        <template #header>
            <div>
                <a id="close_popup" @click="closePopup"></a>
                <h3 class="modal-title">Your Profile, Your Choice</h3>
            </div>
        </template>
        <div class="row">
            <div class="col-sm-12 visibility-popup">
                <p><strong>Stay connected on Multi Me!</strong></p>
                <p>When your profile is visible, other members can find you and invite you to join their Circles and
                    Groups.</p>
                <p>Being visible doesn’t give others access to your private information.</p>

                <section class="visibility-popup__section">
                    <h4>Prefer to stay private?</h4>
                    <p>Use the switch below to hide your profile from searches.</p>
                    <p>You can change this anytime in <a :href="accountSettingsLink">Account Settings</a>.</p>
                </section>
            </div>
        </div>
        <div class="row visibility-popup__confirm">
            <div class="col-sm-12">
                <vue-switch-with-label
                        label="Hide my Profile"
                        name="hide_my_profile"
                        v-model="value"
                        help-link="https://multime.freshdesk.com/support/solutions/articles/44002778588--profile-visibility"
                        @update:model-value="onInput"
                ></vue-switch-with-label>
            </div>
        </div>
        <template #footer>
            <div>
                <button class="btn btn-mm btn-green save-button" @click="save">
                    OK
                </button>
            </div>
        </template>
    </modal>
</template>

<script>
    import notifications from '~/vue/plugins/notifications';
    import { DjangoUrls } from 'DjangoUrls';
    import userprofileSettingsResourceImport from '../../userprofile/userprofile_settings_resource';
    const UserProfileSettingsResource = userprofileSettingsResourceImport();

    export default {
        name: 'VisibilityChangesAcceptPopup',
        data() {
            return {
                opened: false,
                value: false,
                userId: undefined,
            };
        },
        computed: {
            accountSettingsLink() {
                return DjangoUrls['user_update_settings']();
            }
        },
        methods: {
            show(userId, value) {
                this.userId = userId;
                this.value = value;
                this.opened = true;
                return new Promise((resolve, reject) => {
                    this.resolve = resolve;
                    this.reject = reject;
                });
            },
            closePopup() {
                this.opened = false;
                this.reject();
            },
            save() {
                this.opened = false;
                this.resolve();
            },
            onInput(hideProfile) {
                UserProfileSettingsResource.update_profile_visibility(this.userId, !hideProfile)
                    .then(resp => {
                        notifications.success('Profile settings successfully updated');
                    }, err => {
                        notifications.error(err || 'Error');
                    });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @use "styles/const.scss" as *;

    .visibility-popup {
        font-size: $slight-bigger-font-size;
        line-height: 1.5;

        p {
            margin: 0 0 8px;
        }

        a {
            color: $menu-blue;
            font-weight: bold;
            text-decoration: underline;
        }

        &__section {
            margin-top: 20px;

            h4 {
                font-size: $bigger-font-size;
                font-weight: bold;
                margin: 0 0 6px;
            }
        }
    }

    .visibility-popup__confirm {
        margin-top: 16px;
        font-size: $slight-bigger-font-size;
    }
</style>
